import { Button } from "@synthesis/shared-ui";
import IconExportUpload from "@synthesis/shared-icons/IconExportUpload";
import IconRefresh from "@synthesis/shared-icons/IconRefresh";
import { cn } from "@synthesis/shared-utils";
import dayjs from "dayjs";
import { useMemo } from "react";
import { MonitoringRailwayFilter } from "./monitoring-railway-filter";

type MonitoringPageHeaderProps = {
  updatedAt?: string | null;
  isUpdating: boolean;
  isExporting: boolean;
  isDisabled: boolean;
  railwayId: string;
  isRailwayRestricted: boolean;
  railwayName?: string;
  onRailwayChange: (value: string) => void;
  onRefresh: () => void;
  onExport: () => void;
};

export const MonitoringPageHeader = ({
  updatedAt,
  isUpdating,
  isExporting,
  isDisabled,
  onExport,
  railwayId,
  isRailwayRestricted,
  railwayName,
  onRailwayChange,
  onRefresh,
}: MonitoringPageHeaderProps) => {
  const formattedUpdatedAt = useMemo(() => (updatedAt ? dayjs(updatedAt).format("DD.MM.YYYY, HH:mm") : "Нет данных"), [updatedAt]);

  return (
    <header className="bg-neutrals-white flex flex-col gap-6 rounded-xl p-6">
      <div className="flex flex-col gap-3">
        <h1 className="heading-h4 text-type-common font-bold leading-8">Мониторинг</h1>
        <p className="subtitle-sm text-type-minor">Отображение актуального состояния системы</p>
        {railwayName && <p className="subtitle-sm text-type-common">{railwayName} железная дорога</p>}
      </div>

      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <p className="subtitle-sm text-type-light">
            Актуально на <span className="text-type-common">{formattedUpdatedAt}</span>
          </p>
          <div className="bg-neutrals-95 h-8 w-px shrink-0" aria-hidden />
          <Button
            type="button"
            theme="secondary"
            size="sm"
            icon={<IconRefresh className={cn("size-5", isUpdating && "animate-spin")} />}
            aria-label="Обновить"
            onClick={onRefresh}
            disabled={isUpdating || isDisabled}
          />
          <p className="subtitle-sm text-type-light">Обновить</p>
        </div>

        <div className="flex items-center gap-3">
          <Button
            type="button"
            theme="secondary"
            size="sm"
            leftIcon={<IconExportUpload className="size-5" />}
            onClick={onExport}
            disabled={isExporting || isDisabled}
          >
            {isExporting ? "Экспортируется…" : "Экспортировать"}
          </Button>
          {!isRailwayRestricted && (
            <>
              <div className="bg-neutrals-95 h-8 w-px shrink-0" aria-hidden />
              <MonitoringRailwayFilter value={railwayId} onChange={onRailwayChange} />
            </>
          )}
        </div>
      </div>
    </header>
  );
};
